import styled, { css } from 'styled-components'
import { COLORS } from '@styles/colors'
import { DEVICES } from '@constants/global'
import { FONTS } from '@styles/fonts'

export const AddToCalendar = styled.div`
  margin-left: auto;
  position: relative;

  svg {
    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
`

export const AddToCalendarLabel = styled.span`
  font-size: 12px !important;
  text-transform: uppercase;
  font-family: ${FONTS.bold};

  @media ${DEVICES.mobile} {
    display: none;
  }
`

export const AddToCalendarDropdown = styled.div`
  position: absolute;
  width: 100%;
  min-width: 180px;
  top: calc(100% + 10px);
  right: 0;
  background-color: ${COLORS.nature[95]};
  border-radius: 5px;
  padding: 10px 0;
  z-index: 99;
  display: none;

  ${({ open }) =>
    open &&
    css`
      display: block;
    `}
`

export const AddToCalendarDropdownItem = styled.a`
  display: block;
  padding: 6px 16px;
`
